import * as C from '../../constants';
import defaultState from './defaultState';

export default {

  [C.SKI_RENTAL_RESET_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region Ski rental participant
  [C.SKI_RENTAL_PARTICIPANT_UPDATE_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PARTICIPANT_UPDATE_SUCCESS](state, payload) {
    payload.skiRental.areaId = payload.skiRental.area.id;
    const rentalItem = Object.assign({}, payload.skiRental);
    const items = Object.values(state.rentals.items).map(
      rental => (
        rental.id === rentalItem.id ? rentalItem : rental
      ),
    );
    state.rentals = {
      ...state.rentals,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PARTICIPANT_UPDATE_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Ski rental products
  [C.SKI_RENTAL_PRODUCTS_LOAD_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: true,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCTS_LOAD_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCTS_LOAD_SUCCESS](state, payload) {
    state.rentals = {
      ...state.rentals,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Available ski rental products
  [C.SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_PENDING](state) {
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      itemsLoading: true,
      itemsError: undefined,
    };
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_FAILURE](state, payload) {
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_SUCCESS](state, payload) {
    const allLevelTypes = [];
    const allSkiTypes = [];
    const allPackageTypes = [];
    for (let i = 0; i < payload.length; i += 1) {
      if (!allLevelTypes.includes(payload[i].level)) {
        allLevelTypes.push(payload[i].level);
      }
      if (!allSkiTypes.includes(payload[i].skiType)) {
        allSkiTypes.push(payload[i].skiType);
      }
      if (!allPackageTypes.includes(payload[i].package)) {
        allPackageTypes.push(payload[i].package);
      }
    }
    state.levelTypes = {
      ...state.levelTypes,
      items: allLevelTypes,
      itemsLoading: false,
      itemsError: undefined,
    };
    state.skiTypes = {
      ...state.skiTypes,
      items: allSkiTypes,
      itemsLoading: false,
      itemsError: undefined,
    };
    state.packageTypes = {
      ...state.packageTypes,
      items: allPackageTypes,
      itemsLoading: false,
      itemsError: undefined,
    };
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Ski rental product
  [C.SKI_RENTAL_PRODUCT_CREATE_PENDING](state) {
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_CREATE_SUCCESS](state) {
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_CREATE_FAILURE](state, payload) {
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCT_UPDATE_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_UPDATE_SUCCESS](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_UPDATE_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCT_PRICE_UPDATE_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_PRICE_UPDATE_SUCCESS](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_PRICE_UPDATE_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCT_DELETE_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_DELETE_SUCCESS](state, skiRentalProductId) {
    const items = Object.values(state.rentals.items).map((bookingRental) => {
      let skiRentalProducts = bookingRental.skiRentalProducts;
      skiRentalProducts = [
        ...skiRentalProducts.filter(skiRentalProduct => skiRentalProduct.id !== skiRentalProductId),
      ];
      return {
        ...bookingRental,
        skiRentalProducts,
      };
    });
    state.rentals = {
      ...state.rentals,
      items,
      saveLoading: false,
      saveError: undefined,
    };
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_DELETE_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
    state.availableRentalProducts = {
      ...state.availableRentalProducts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCT_STOP_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_STOP_SUCCESS](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_STOP_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCT_CANCEL_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_CANCEL_SUCCESS](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_CANCEL_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_SUCCESS](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_SUCCESS](state, payload) {
    const currentSkiRentalProduct = {
      ...Object.assign({}, payload.skiRentalProduct),
      supplierRef: payload.supplierRef,
    };
    const items = Object.values(state.rentals.items).map((bookingRental) => {
      const skiRentalProducts = Object.values(bookingRental.skiRentalProducts).map(
        rental => (
          rental.id === currentSkiRentalProduct.id ? currentSkiRentalProduct : rental
        ),
      );

      return {
        ...bookingRental,
        skiRentalProducts,
      };
    });
    state.rentals = {
      ...state.rentals,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_SUCCESS](state) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Ski rental search available products
  [C.SKI_RENTAL_SEARCH_BOOKING_PARTICIPANT_SET](state, selectedBookingParticipant) {
    state.search.selectedBookingParticipant = selectedBookingParticipant;
  },

  [C.SKI_RENTAL_SEARCH_START_DATE_SET](state, selectedStartDate) {
    state.search.selectedStartDate = selectedStartDate;
  },

  [C.SKI_RENTAL_SEARCH_NUMBER_OF_DAYS_SET](state, selectedNumberOfDays) {
    state.search.selectedNumberOfDays = selectedNumberOfDays;
  },

  [C.SKI_RENTAL_SEARCH_LEVEL_TYPES_SET](state, selectedMultipleLevelTypeIds) {
    state.search.selectedMultipleLevelTypes = selectedMultipleLevelTypeIds;
  },

  [C.SKI_RENTAL_SEARCH_SKI_TYPES_SET](state, selectedMultipleSkiTypeIds) {
    state.search.selectedMultipleSkiTypes = selectedMultipleSkiTypeIds;
  },

  [C.SKI_RENTAL_SEARCH_AREA_SET](state, selectedAreaId) {
    state.search.selectedAreaId = selectedAreaId;
  },
  // endregion

  // region Ski rental change product
  [C.SKI_RENTAL_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET](state, selectedBookingParticipant) {
    state.changeProduct.selectedBookingParticipant = selectedBookingParticipant;
  },

  [C.SKI_RENTAL_CHANGE_PRODUCT_START_DATE_SET](state, selectedStartDate) {
    state.changeProduct.selectedStartDate = selectedStartDate;
  },

  [C.SKI_RENTAL_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET](state, selectedNumberOfDays) {
    state.changeProduct.selectedNumberOfDays = selectedNumberOfDays;
  },

  [C.SKI_RENTAL_CHANGE_PRODUCT_LEVEL_TYPE_SET](state, selectedLevelTypeId) {
    state.changeProduct.selectedLevelTypeId = selectedLevelTypeId;
  },

  [C.SKI_RENTAL_CHANGE_PRODUCT_SKI_TYPE_SET](state, selectedSkiTypeId) {
    state.changeProduct.selectedSkiTypeId = selectedSkiTypeId;
  },

  [C.SKI_RENTAL_CHANGE_PRODUCT_PACKAGE_TYPE_SET](state, selectedPackageTypeId) {
    state.changeProduct.selectedPackageTypeId = selectedPackageTypeId;
  },

  [C.SKI_RENTAL_CHANGE_PRODUCT_PERSON_CATEGORY_SET](state, personCategoryId) {
    state.changeProduct.selectedPersonCategoryId = personCategoryId;
  },
  // endregion

  [C.BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_PENDING](state) {
    state.pickupPlaces = {
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_SUCCESS](state, payload) {
    state.pickupPlaces = {
      loading: false,
      error: false,
      items: payload,
    };
  },

  [C.BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_FAILURE](state) {
    state.pickupPlaces = {
      loading: false,
      error: true,
      items: [],
    };
  },

  [C.BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_PENDING](state) {
    state.savePickupPlace = {
      loading: true,
      error: false,
      success: false,
    };
  },

  [C.BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_SUCCESS](state) {
    state.savePickupPlace = {
      loading: false,
      error: false,
      success: true,
    };
  },

  [C.BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_FAILURE](state) {
    state.savePickupPlace = {
      loading: false,
      error: true,
      success: false,
    };
  },

  [C.SKI_RENTAL_ASSIGN_PARTICIPANT_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: true,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_ASSIGN_PARTICIPANT_SUCCESS](state, payload) {
    state.rentals = {
      ...state.rentals,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_ASSIGN_PARTICIPANT_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_SUCCESS](state) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_FAILURE](state, payload) {
    state.rentals = {
      ...state.rentals,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_BOOK_BY_XML_PENDING](state) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: true,
    };
  },

  [C.SKI_RENTAL_BOOK_BY_XML_SUCCESS](state, payload) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: false,
      items: payload,
    };
  },

  [C.SKI_RENTAL_BOOK_BY_XML_FAILURE](state) {
    state.rentals = {
      ...state.rentals,
      itemsLoading: false,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/rental/mutations.js